"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnotherTranslation = void 0;
const react_1 = __importStar(require("react"));
const util_1 = require("./util");
const api_1 = require("./api");
const CopilotSetting_1 = require("./CopilotSetting");
const fromFetchSSEStream_1 = require("copilot-js/dist/helpers/fromFetchSSEStream");
const reportTokenUsage_1 = require("@/utils/reportTokenUsage");
const AnotherTranslation = ({ text, langId, context, prompt, additionalPrompt, delay, description, projectId, onChangeTranslation, onApply, }) => {
    const [translation, setTranslation] = react_1.default.useState("");
    const [isStop, setIsStop] = react_1.default.useState(false);
    (0, react_1.useEffect)(() => {
        if (isStop) {
            onChangeTranslation === null || onChangeTranslation === void 0 ? void 0 : onChangeTranslation(translation);
        }
    }, [isStop]);
    const isMounted = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(() => {
        if (isMounted.current)
            return;
        isMounted.current = true;
        const controller = new AbortController();
        const callback = (fragment) => {
            setTranslation((prev) => {
                return (prev || "") + fragment;
            });
        };
        const filter = (0, util_1.createFilter)(callback, false);
        const responsePromise = (() => __awaiter(void 0, void 0, void 0, function* () {
            if (delay)
                yield new Promise((resolve) => setTimeout(resolve, delay || 0));
            // const context = await contextPromise;
            const model = (0, CopilotSetting_1.getCopilotSetting)().proofreadingModel;
            return (0, api_1.chatCompletionWithContext)({
                model,
                context: context !== null && context !== void 0 ? context : [],
                controller,
                prompt: Object.assign(Object.assign({}, api_1.defaultTranslationPrompt), (prompt !== null && prompt !== void 0 ? prompt : {})),
                additionalPrompt,
                params: {
                    langId,
                    text,
                    translation,
                },
            });
        }))();
        (0, fromFetchSSEStream_1.fromFetchSSEStream)({
            callback: (data) => {
                var _a;
                // ストリームが完了した時点でトークン使用量を報告
                if (data.usage) {
                    const model = (0, CopilotSetting_1.getCopilotSetting)().proofreadingModel;
                    (0, reportTokenUsage_1.reportTokenUsage)(model !== null && model !== void 0 ? model : "unknown", data.usage.prompt_tokens, data.usage.completion_tokens, projectId).catch(console.error);
                }
                if (data.choices.length === 0)
                    return;
                filter(data.choices[0].delta.content || "");
                if (((_a = data.choices[0]) === null || _a === void 0 ? void 0 : _a.finish_reason) === "stop") {
                    setIsStop(true);
                }
            },
            controller,
            responsePromise,
        });
    }, [text, langId, prompt, context, delay]);
    if (!translation)
        return null;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "border-bottom", style: { padding: "10px" } },
            react_1.default.createElement("button", { onClick: () => onApply(translation), className: "btn btn-light", style: { display: "block", width: "100%" }, "data-tooltip-id": "tooltip-multiline", "data-tooltip-content": description, "data-tooltip-delay-show": 100, "data-tooltip-delay-hide": 100 },
                react_1.default.createElement("div", { style: {
                        textAlign: "left",
                        wordBreak: "break-all",
                    } }, translation)))));
};
exports.AnotherTranslation = AnotherTranslation;
